import React, { useContext, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

import useMediaQuery from "../../hooks/useMediaQuery";

import FiltersTransactions from "./FiltersTransanctions";
import TransactionsTables from "./TransactionsTables";

import AuthContext from "../../context/authentication/authContext";
import PortalContext from "../../context/portal/portalContext";
import ModalMui from "../core/ModalMui"

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    //padding: theme.spacing(3),
    height: "100%",
  },
  componentTitle: {
    fontSize: "24px",
    color: "#263AE3",
    marginBottom: 15,
  },
  referencesOptionsModal:{
    display:'flex',
    justifyContent:'center',
    flexDirection:'row',
    alignItems: 'center',
  },
  referencesOptionsModalElement:{},
  referencesOptionsModalElementButton:{
   cursor:'pointer',
   margin:"20px",
   padding: "20px",
   fontSize: "14px",
   background:'#001070',
   color:'#ffffff',
   borderRadius:'6px',
   },
  referencesOptionsModalCancel:{
    padding:'20px',
    background: 'rgba(218, 41, 29, 0.86)',
    borderRadius:'6px',
    //marginRight:'15px',
    fontWeight: '500',
    fontSize: '14px',
    //lineHeight: '20px',
    textAlign:'center',
    color:'#ffffff',
    cursor: 'pointer',
  }
}));

const ReferencesOptionsModal=(props)=>{
  function selectReference(event){
      const dt = props.dt
      dt.typesToRefer = parseInt(event.currentTarget.attributes.type.value)
      sessionStorage.setItem('referenceData',JSON.stringify(dt) )
      window.location.href='/app/new-bill'
  }
  return(
      <div className={props.classes.referencesOptionsModal}>
          {
            
              props.data.map((x,k)=>{
                  return(

                      <div className={props.classes.referencesOptionsModalElement} key={k}>
                         <button className={props.classes.referencesOptionsModalElementButton} type={x.typesToRefer} onClick={selectReference}>{x.label}</button>
                      </div>
                  )
              })
          }
         <button className={props.classes.referencesOptionsModalCancel} onClick={props.closeModal}>Cancelar</button>
      </div>
  )
}

const Transactions = (props) => {
  const authContext = useContext(AuthContext);
  const portalContext = useContext(PortalContext);
  const { authenticatedUser } = authContext;
  const { terminals, getDashboardData } = portalContext;

  const [modalShow, setModalShow] = useState(false);
  const showModal = () => setModalShow(true);
  const closeModal = () => setModalShow(false);
  const [modalContent, setModalContent] = useState(null);
  const [modalTitle, setModalTitle] = useState("");
  const [modalSubTitle, setModalSubTitle] = useState("");

  function showReferencesOptions(data,dt){
    setModalTitle("Referenciar Documento")
    setModalSubTitle("Por favor seleccione una opción:")
    setModalContent(<ReferencesOptionsModal data={data} dt={dt} closeModal={closeModal} classes={classes}/>)
    showModal()
  }

  useEffect(() => {
    if (localStorage.getItem("hasToChange") === "true") {
      props.history.push("/app/change-password?show-terms-of-use=1");
    }
    authenticatedUser();
    getDashboardData();
  }, []);

  const classes = useStyles();
  const isMobile = useMediaQuery("max-width", 600);
  return (
    <div
      className={classes.root}
      style={{ padding: !isMobile ? "24px" : "0px" }}
    >
      <Grid container spacing={3} style={{ marginBottom: "60px" }}>
        {!isMobile && (
          <Grid item xs={4}>
            <Typography className={classes.componentTitle}>
              Transacciones
            </Typography>
            <FiltersTransactions terminals={terminals} />
          </Grid>
        )}
        <Grid item xs={!isMobile ? 8 : 12}>
          <Grid item xs={12}>
            <TransactionsTables showReferencesOptions={showReferencesOptions} />
          </Grid>
        </Grid>
      </Grid>
      {modalShow &&
        <ModalMui
          modalShow={modalShow}
          showModal={showModal}
          closeModal={closeModal}
          modalTitle={modalTitle}
        >
          {modalSubTitle}
          {modalContent}
        </ModalMui>
      }
    </div>
  );
};

export default Transactions;
